module.exports = __webpack_public_path__ + "img/simonw-pro.2105c734.jpg";